import * as types from '../mutation-types'

const state = {
  // Lendo os enderelos selecionados de string para JSON de localStorage
//   main: JSON.parse(localStorage.getItem('enderecoAtivo')) || {}
  main: {}
}

const mutations = {
  [types.ATUALIZAR_ENDERECO_ATIVO] (state, endereco) {
    /**
       * Atualiza O produto selecionado e salva como string em localStorage
       */
     state.main = endereco;
    //  localStorage.setItem('enderecoAtivo', JSON.stringify(endereco));
  },
  [types.REMOVER_ENDERECO_ATIVO] (state) {
    /**
       * Limpa O produto selecionados
       */
     state.main = {};
    //  localStorage.removeItem('enderecoAtivo');
  },

}

export default {
  state,
  mutations
}

